const state = () => ({
  allMerchants: [],
  totalMerchants: 0,
  loading: false,
  errors: [],
  flashErrorMessage: '',
  flashError: false,
  merchant: null,
  totalPage: 0,
  switchId: null,
  countDataSwitch: 0,
  switchStatus: false,
  countDoneSwitch: 0,
  countSameSwitch: 0,
  percentage: 0,
  allInputerData: [],
  loadingInputer: false,
  allApprover1Data: [],
  loadingApprover1: false,
  allApprover2Data: [],
  loadingApprover2: false,
  loadingDataPic: false,
  showProgressDialog: false,
  dialogPercentage: 0,
  showProgressBar: false,  
  progressTitle: '',
  progressColor: 'green',
  intervalInsert: null,
  intervalSwitch: null,
  loadingPic: false

});

export default state;